import { useState, useEffect } from 'react';
import { getCurrentUser } from '../services/user.service.js';
import useAuthStore from '../auth.store.js';
import useAuth from './useAuth.js';

const useCurrentUser = ()=>{
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const storeUser = useAuthStore((state)=>state.user);
    const storeLoading = useAuthStore((state)=>state.userLoading);
    const storeError = useAuthStore((state)=>state.userError);
    const { isLoggedIn, isInitializing } = useAuth();
    useEffect(()=>{
        let isMounted = true;
        const fetchUser = async ()=>{
            try {
                setLoading(true);
                setError(null);
                const currentUser = await getCurrentUser();
                if (isMounted) {
                    setUser(currentUser);
                }
            } catch (err) {
                if (isMounted) {
                    setError(err);
                }
            } finally{
                if (isMounted) {
                    setLoading(false);
                }
            }
        };
        if (isLoggedIn && !isInitializing && !storeUser) {
            fetchUser();
        }
        return ()=>{
            isMounted = false;
        };
    }, []);
    // Use store data if available and not forcing refresh
    const finalUser = storeUser || user;
    const finalLoading = storeLoading || loading;
    const finalError = storeError || error;
    return {
        user: finalUser,
        loading: finalLoading,
        error: finalError,
        refetch: ()=>getCurrentUser(true),
        // Convenience methods
        isAuthenticated: !!finalUser,
        userId: finalUser?.userId,
        username: finalUser?.username,
        email: finalUser?.attributes?.email,
        customerId: finalUser?.customerId,
        isFederated: finalUser?.isFederated() ?? false,
        // Password reset flag
        isPasswordResetRequired: finalUser?.payload?.['custom:force_reset_pw'] === 'true'
    };
};

export { useCurrentUser as default, useCurrentUser };
//# sourceMappingURL=useCurrentUser.js.map
